export const attorneys = [
  {
    id: 1,
    name: 'David Allen Matthews',
    title: 'Senior Partner, Intellectual Property & Trademark Strategy ',
    experience: 'Over twenty-five years',
    education: 'University of the Pacific, McGeorge School of Law, J.D.',
    barAdmissions: 'State Bar of California (No. 196906), North Carolina State Bar, U.S. District Courts for all districts in NC and CA',
    specialization: 'Commercial Technology Transactions, Trademark Prosecution, Strategic Business Counseling',
    bio: 'David is a highly accomplished legal strategist with nearly three decades of experience helping businesses secure their competitive edge. Admitted to the California Bar in 1998, he has spent his career at the intersection of technology and intellectual property, advising clients on the complexities of trademark registration and brand protection in a global marketplace. David’s expertise extends beyond simple filings; he serves as a comprehensive counselor for startups and established enterprises, guiding them through business entity formation, master service agreements, and sophisticated IP audits. His approach is rooted in the belief that a robust legal foundation—anchored by strong trademark and data privacy protections—is the primary driver of long-term business value.',
    notableAchievements: [
      'Successfully navigated complex trademark and commercial disputes for a diverse range of technology and service-based firms',
      'Developed enterprise-level IP and software licensing frameworks for international corporations',
      'Recognized by Best Lawyers in America for excellence in business law and strategic transactions'
    ],
    practiceAreas: ['Trademark Registration & Maintenance', 'SaaS and Technology Licensing', 'Business Formation & Corporate Governance', 'Intellectual Property Enforcement', 'Data Privacy & Security Compliance (GDPR/CCPA)' ],

  },
  {
    id: 2,
    name: 'Benjamin Foster',
    title: 'Senior Partner, Corporate Law',
    experience: 'Over two decades',
    education: 'Harvard Law School, J.D., 1998',
    barAdmissions: 'California State Bar, New York State Bar, U.S. Supreme Court',
    specialization: 'Corporate Transactions, M&A, Securities Law',
    bio: 'Benjamin has successfully represented Fortune 500 companies in complex mergers, acquisitions, and corporate restructuring matters. He has closed transactions worth billions and regularly advises C-suite executives on strategic corporate matters.',
    notableAchievements: [
      'Lead counsel in numerous M&A transactions',
      'Named Corporate Lawyer of the Year by Legal Excellence Awards',
      'Published author on corporate governance and securities regulation'
    ],
    practiceAreas: ['Mergers & Acquisitions', 'Corporate Governance', 'Securities Compliance', 'Business Transactions'],
  },
  {
    id: 3,
    name: 'James Lee Michaels',
    title: 'Partner, Intellectual Property',
    experience: 'Over a decade',
    education: 'Georgetown University Law Center, J.D., 2010; B.S. Electrical Engineering, University of Virginia, 2007',
    barAdmissions: 'Virginia State Bar, District of Columbia Bar, USPTO (Patent Bar)',
    specialization: 'Intellectual Property, Patent Prosecution, Trademark & Trade Secret Litigation',
    bio: 'James is a seasoned intellectual property expert with a strong technical background, advising clients on patent prosecution, trademark portfolio strategy, and trade secret protection. He has helped startups and established enterprises secure and enforce their IP rights across domestic and international markets, and regularly counsels on IP due diligence in mergers and acquisitions.',
    notableAchievements: [
      'Secured patent protection for innovative technologies across multiple industries',
      'Successfully litigated high-profile trademark infringement cases',
      'Recognized as a Rising Star in Intellectual Property by Super Lawyers'
    ],
    practiceAreas: ['Patent Prosecution', 'Trademark Strategy', 'Trade Secret Litigation', 'IP Portfolio Management'],
  },
  {
    id: 4,
    name: 'Rachel Anderson',
    title: 'Partner, Intellectual Property',
    experience: 'Extensive experience',
    education: 'Stanford Law School, J.D., 2005; B.S. Computer Science, MIT, 2002',
    barAdmissions: 'California State Bar, USPTO (Patent Bar)',
    specialization: 'Trademark & Copyright Law, Patent Litigation',
    bio: 'Rachel specializes in intellectual property protection, having secured numerous trademarks and copyrights for clients across various industries. Her technical background in computer science gives her unique insight into technology-related IP matters.',
    notableAchievements: [
      'Successfully defended clients in IP infringement cases',
      'Secured trademark protection for major companies',
      'Recognized as Top IP Attorney by National Law Journal'
    ],
    practiceAreas: ['Trademark Registration', 'Copyright Protection', 'Patent Litigation', 'IP Portfolio Management'],
  },
  {
    id: 5,
    name: 'Marcus Williams',
    title: 'Partner, Business Litigation',
    experience: 'Significant track record',
    education: 'Yale Law School, J.D., 2003; B.A. Economics, Princeton University, 1999',
    barAdmissions: 'California State Bar, Federal Courts (9th Circuit)',
    specialization: 'Commercial Disputes, Compliance, White Collar Defense',
    bio: 'Marcus has a proven track record in high-stakes business litigation and anti-corruption compliance matters with exceptional success. He has represented clients in complex commercial disputes involving breach of contract, fraud, and regulatory investigations.',
    notableAchievements: [
      'Won substantial settlements and judgments for clients',
      'Successfully defended clients in federal investigations',
      'Listed in Best Lawyers in America for Business Litigation'
    ],
    practiceAreas: ['Commercial Litigation', 'Anti-Corruption Compliance', 'Business Disputes', 'Regulatory Defense'],
  },
  {
    id: 6,
    name: 'Victoria Martinez',
    title: 'Partner, Immigration Law',
    experience: 'Comprehensive expertise',
    education: 'Columbia Law School, J.D., 2008; M.A. International Relations, Georgetown, 2005',
    barAdmissions: 'California State Bar, New York State Bar',
    specialization: 'Business Immigration, Visas, Employment Authorization',
    bio: 'Victoria has helped numerous businesses navigate complex immigration matters, securing visas and work permits for international talent. She specializes in employment-based immigration and has successfully handled cases for multinational corporations and startups.',
    notableAchievements: [
      'Processed successful visa applications for global companies',
      'Expert witness in immigration policy hearings',
      'Featured speaker at American Immigration Lawyers Association conferences'
    ],
    practiceAreas: ['Employment-Based Immigration', 'H-1B & L-1 Visas', 'Green Card Applications', 'Corporate Immigration Compliance'],
  },
  
  
];

export const paralegals = [
  {
    id: 6,
    name: 'Alexandra Cooper',
    title: 'Senior Paralegal',
    experience: '8 years',
    specialization: 'Corporate Documentation',
    bio: 'Alexandra manages complex corporate filings and documentation with exceptional attention to detail. She supports our corporate team in M&A transactions and business formation matters.',
  },
  {
    id: 7,
    name: 'Daniel Brooks',
    title: 'Paralegal',
    experience: '5 years',
    specialization: 'Legal Research',
    bio: 'Daniel provides comprehensive legal research and case preparation support for litigation matters. He assists in drafting legal memoranda and case analysis.',
  },
  {
    id: 8,
    name: 'Sophia Reynolds',
    title: 'Paralegal',
    experience: '4 years',
    specialization: 'IP Administration',
    bio: 'Sophia specializes in trademark and copyright filing procedures and maintains our IP portfolio database. She coordinates with USPTO for trademark applications.',
  },
  {
    id: 9,
    name: 'Christopher Hayes',
    title: 'Junior Paralegal',
    experience: '3 years',
    specialization: 'Compliance Documentation',
    bio: 'Christopher assists with compliance audits and anti-corruption documentation for government contracting matters. He supports due diligence reviews.',
  },
];
